/**
 * Rounds the number according to the following rules:
 * - If number < 1000, the result is a multiple of 50. 25 and 75 are rounded up.
 * - If number >= 1000, the result is a multiple of 100. 50 are rounded up.
 * 
 * Examples: roundDynamic(746) === 750, roundDynamic(7450) === 7500
 */
export function roundDynamic(number: number): number {
  let multiple = 0;

  if (number < 1000) {
    multiple = 50;
  } else {
    multiple = 100;
  }

  const quotient = Math.floor(number / multiple);
  const remainder = number % multiple;
  return 2 * remainder >= multiple
    ? (quotient + 1) * multiple
    : quotient * multiple;
}

/**
 * Rounds the number to the nearest number which is a multiple of the given multiple.
 * 
 * Example: roundMultiple(22, 4) === 24
 */
export function roundMultiple(number: number, multiple: number): number {
  const quotient = Math.floor(number / multiple);
  const remainder = number % multiple;
  return 2 * remainder >= multiple
    ? (quotient + 1) * multiple
    : quotient * multiple;
}

/**
 * Rounds the number such that the result has the given number of digits.
 * Example: roundDecimal(0.15, 1) === 0.2
 */
export function roundDecimal(number: number, digits: number) {
  const factor = 10 ** digits;
  return Math.round(number * factor) / factor;
}
